import log from 'salvo-lite/log'
class Header {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._megaMenu = elem.querySelectorAll('.megamenu')
        this._announcement = document.querySelector('.announcement')
        this._lightLogo = elem.querySelectorAll('.site-header__logo.light')
        this._darkLogo = elem.querySelectorAll('.site-header__logo.dark')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        if (window.innerWidth > 768) {
            for (var i = 0; i < this._megaMenu.length; i++) {
            }
        }
        if (!this._elem.classList.contains('site-header__relative')) {
            this._elem.style.top = this._announcement.offsetHeight + 'px'
        }
        window.addEventListener('scroll', e => {
            if (window.scrollY > this._announcement.offsetHeight + this._elem.offsetHeight) {
                this._elem.classList.add('scrolled')
                for (var m = 0; m < this._megaMenu.length; m++) {
                }
                if (!this._elem.classList.contains('site-header__relative')) {
                    this._darkLogo.forEach(logo => logo.classList.remove('hide'))
                    this._lightLogo.forEach(logo => logo.classList.add('hide'))
                    // this._darkLogo.classList.remove('hide')
                    // this._lightLogo.classList.add('hide')
                }
            } else {
                this._elem.classList.remove('scrolled')
                for (var d = 0; d < this._megaMenu.length; d++) {
                    this._megaMenu[d].classList.remove('megamenu-open')
                }
                if (!this._elem.classList.contains('site-header__relative')) {
                    this._elem.style.top = this._announcement.offsetHeight + 'px'
                    this._darkLogo.forEach(logo => logo.classList.add('hide'))
                    this._lightLogo.forEach(logo => logo.classList.remove('hide'))
                    // this._darkLogo.classList.add('hide')
                    // this._lightLogo.classList.remove('hide')
                }
            }
        })
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Header.js